import { UAContext } from "@quentin-sommer/react-useragent";
import { useParams } from "@remix-run/react";
import React from "react";
import { useTranslation } from "react-i18next";
import splitIntoSegmentsAndGetMidpoints from "~/utils/splitIntoSegmentsAndGetMidpoints";
import Product from "./Product";

export default function Products({ products, cookie, user }) {
  const params = useParams();
  const { t, i18n } = useTranslation();
  const { uaResults } = React.useContext(UAContext);
  const [showAll, setShowAll] = React.useState(false);

  const ranges = splitIntoSegmentsAndGetMidpoints({
    numbers: products.map((r) => r.inventory?.quality && r.inventory.quality),
    segmentsCount: 3,
  });

  const filteredProducts = products;
  const productsToShow = showAll
    ? filteredProducts
    : filteredProducts.slice(0, uaResults.mobile ? 5 : 8);

  return (
    <section>
      {productsToShow.map((product, index) => (
        <Product
          key={product._id}
          product={product}
          productsToShow={productsToShow}
          setShowAll={setShowAll}
          index={index}
          showAll={showAll}
          ranges={ranges}
          cookie={cookie}
          params={params}
          user={user}
        />
      ))}
    </section>
  );
}
